"use strict";exports.__esModule = true;exports.symbol = symbol;function symbol() {
  // eslint-disable-next-line max-len,quotes
  return '<symbol viewbox="0 0 24 24" id=icon-chevron-down><path d="M12.376 17.927a.997.997 0 0 0 .331-.22l8-8a1 1 0 0 0-1.414-1.414L12 15.586 4.707 8.293a1 1 0 0 0-1.414 1.414l8 8a1 1 0 0 0 1.083.22Z"></path></symbol>';
}